import {
  Breakpoints,
  Carousel,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import { type StaticImageData } from 'next/image';
import type { FC } from 'react';

import { type SubCategory } from '../../../__generated-gql-types__/globalTypes';
import BusinessImage from '../../../assets/images/masters-featured-images/Business.png';
import DataScienceImage from '../../../assets/images/masters-featured-images/Data-Science.png';
import EducationImage from '../../../assets/images/masters-featured-images/Education.png';
import EngineeringImage from '../../../assets/images/masters-featured-images/Engineering.png';
import HumanitiesImage from '../../../assets/images/masters-featured-images/Humanities.png';
import NaturalSciencesImage from '../../../assets/images/masters-featured-images/Natural-Sciences.png';
import PublicDegreesImage from '../../../assets/images/masters-featured-images/Public-Degrees.png';
import MBADeferredImage from '../../../assets/images/mba-featured-images/MBA-Deferred.png';
import MBAExecutiveImage from '../../../assets/images/mba-featured-images/MBA-Executive.png';
import MBAOnlineImage from '../../../assets/images/mba-featured-images/MBA-Online.png';
import MBAPartTimeImage from '../../../assets/images/mba-featured-images/MBA-PartTime.png';
import MBATraditionalImage from '../../../assets/images/mba-featured-images/MBA-Traditional.png';
import { FeaturedFilterCard } from '../FeaturedFilterCard';

const SUBCATEGORY_FILTERS_IMAGES: Record<string, StaticImageData> =
  Object.freeze({
    // MBA
    'traditional-full-time-mba': MBATraditionalImage,
    'deferred-mba': MBADeferredImage,
    'executive-mba': MBAExecutiveImage,
    'part-time-mba': MBAPartTimeImage,
    'online-mba': MBAOnlineImage,
    // Masters
    'business-degrees': BusinessImage,
    'data-science-degrees': DataScienceImage,
    'education-degrees': EducationImage,
    'engineering-degrees': EngineeringImage,
    'humanities-degrees': HumanitiesImage,
    'natural-science-degrees': NaturalSciencesImage,
    'public-degrees': PublicDegreesImage,
  });

interface BrowseSubCategoriesProps {
  subCategoryList: SubCategory[];
  subCategoryTitle: string;
  onClick: (value: string) => void;
}

const BrowseSubCategories: FC<BrowseSubCategoriesProps> = ({
  subCategoryList,
  subCategoryTitle,
  onClick,
}) => {
  const isMd = useMediaQuery(Breakpoints.MD);
  const isLg = useMediaQuery(Breakpoints.LG);

  const featuredFilters = subCategoryList.map((val) => ({
    value: val.slug,
    label: val.name,
  }));

  return featuredFilters ? (
    <Carousel
      disableArrowGradient
      swiperProps={{
        slidesPerGroupAuto: false,
        slidesPerView: isLg ? 4 : isMd ? 3 : 1.15,
        spaceBetween: 16,
      }}
      title={`Browse by ${subCategoryTitle.toLowerCase()}`}
      items={featuredFilters.map(({ label, value }) => (
        <FeaturedFilterCard
          key={value}
          title={
            value === 'traditional-full-time-mba' ? 'Full-Time MBA' : label
          }
          image={SUBCATEGORY_FILTERS_IMAGES[value]}
          onClick={() => onClick(value)}
        />
      ))}
    />
  ) : null;
};

export default BrowseSubCategories;
